var map = {
	"./account.png": "8190",
	"./delivery.png": "90f5",
	"./faq.png": "14a3",
	"./flowers.png": "8799",
	"./free-flowers.png": "74a7",
	"./general.png": "1c57",
	"./gifting.png": "01d4",
	"./shop.png": "d691"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de3f";